/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
/* eslint-disable dot-notation */
export function onResize(element, cb) {
    const ResizeObserver = window['ResizeObserver'] ||
        require('@juggle/resize-observer').ResizeObserver;
    const observer = new ResizeObserver(cb);
    observer.observe(element);
    return () => {
        observer.unobserve(element);
    };
}
